export const getMetadata = state => state.Metadata
